import React, { useCallback } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { AuthCallbackPage } from "../../auth/session";
import { useStoreActions } from "../../store/easy-peasy/hooks";
import type { AuthSessionUser } from "../../auth/session";
import { readCachedAuthMeResponse } from "../../auth/session/authSession.storage";
import { mergeApplicationsOntoSessionUser } from "../../utils/matchesAssignedApplicationOrigin";
import { prefetchModuleConfig } from "../../hooks/useModuleConfig";

const applicationId = (process.env.REACT_APP_APPLICATION_ID ?? "").trim();

const AuthCallback: React.FC = () => {
  const queryClient = useQueryClient();
  const setUserFromMe = useStoreActions((actions) => actions.setUserFromMe);

  const handleSessionReady = useCallback(
    (user: AuthSessionUser) => {
      mergeApplicationsOntoSessionUser(user, readCachedAuthMeResponse());
      queryClient.setQueryData(["auth", "session"], user);
      prefetchModuleConfig(queryClient, applicationId);
      const clientId =
        user.client_id ?? user.clientId ?? user.id ?? user.user_id ?? user.userId;
      if (clientId) {
        setUserFromMe({
          id: String(clientId),
          username: user.full_name ?? user.name ?? user.email ?? "",
          email: user.email ?? "",
        });
      }
    },
    [queryClient, setUserFromMe],
  );

  return <AuthCallbackPage onSessionReady={handleSessionReady} />;
};

export default AuthCallback;
